// Styles
import "./styles.scss";

const StatusBadge = ({ value, statuses = {}, className = "", ...props }) => {
    const statusStyle = statuses[value] || {};
    const { backgroundColor = "#ccc", color = "#000" } = statusStyle;

    const badgeStyle = {
        backgroundColor,
        color,
    };

    return (
        <div
            className={`status-badge ${className}`}
            style={badgeStyle}
            title={value || ""}
            {...props}
        >
            {value || "-"}
        </div>
    );
};

export default StatusBadge;